<template>
  <b-container>
    <b-card>
      <b-form @submit.prevent="save()">
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group label-for="number">
              <template #label>
                Number
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-form-input id="number" v-model="form.number" required />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label-for="message">
              <template #label>
                Message
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-form-input id="message" v-model="form.message" required />
            </b-form-group>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button type="submit" :disabled="isLoading" variant="primary">
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
  },

  mixins: [togglePasswordVisibility],

  data() {
    return {
      isLoading: false,
      form: {
        number: '',
        message: '',
      },
    }
  },

  computed: {
    isAdmin() {
        let role = this.$store.getters['oauth/getActiveUser'].role
        if (!role.includes('admin')) {
            return false
        }
        return true
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    updateData() {
      this.isLoading = true
      this.$http
        .post('/whatsapp', this.form)
        .then(() => {
          this.$notif('Success', 'Data has been successfully updated.', 'success')
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => {
          this.isLoading = false
        })
    },
    async getData() {
      return await this.$http.get(`/whatsapp`)
      .then(res => {
        const data = res.data.data ?? {}
        this.form.number = data.number
        this.form.message = data.message

      })
    },
    save() {
      this.updateData()
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>